import { gql } from '@apollo/client'

export default gql(`
  mutation sendReminderEmail($id: ID!, $emailBody: String!, $link: String!, $studentIds: [ID]!) {
    sendReminderEmail(id: $id, emailBody: $emailBody, link: $link, studentIds: $studentIds) {
      id
    }
  }
`)
